
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ios-mobile-app-development-services",
      function () {
        return require("private-next-pages/ios-mobile-app-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ios-mobile-app-development-services"])
      });
    }
  